import React, {
  useDeferredValue,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import ArrowButton from "../../components/ArrowButton";
import AToZ from "../../components/AToZ";
import FamilyCardJs from "../../components/FamilyCard.js";
import InputSearch from "../../components/InputSearch";
import { useLocation, useNavigate } from "react-router";
import noFamilyFound from "../../assets/images/svg/nofamilyfound.svg";
import Header from "../../components/Header/Header";
import { Observer, observer } from "mobx-react";
import { getOffshoreData, logout } from "../../utils/functions";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
//import SettingsStore from "../../store/SettingsStore";
import PerformanceStore from "../../store/PerformanceStore";
import ProfileStore2 from "../../store/ProfileStore2";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import ReportsStore from "../../store/ReportsStore";
import { setCookie } from "../../utils/cookie";
import { getValue } from "../../utils/indexedDB";
import Log from "../../components/Analytics/Equity/Log";
import { defaultSecondaryRMData, OFFSHORE } from "../../utils/constants.js";
import PageHeading from "../../components/PageHeading/PageHeading";

const SelectFamilies = observer(({ user }) => {
  const [search, setSearch] = useState("");
  const defsearch = useDeferredValue(search);
  const cardsRef = useRef(null);
  const parentScroll = useRef(null);
  const searchInputRef = useRef(null);
  const buttonRef = useRef(null);
  const location = useLocation();
  const [start, setStart] = useState(false);
  const [isSort, setSort] = useState("asc");
  const [isSorting, setIsSorting] = useState(false);
  const [fullScreenLoading, setFullScreenLoading] = useState(true);
  const [vertualRows, setVertualRows] = useState([]);
  const [rememberedFamilyData, setRememberedFamilyData] = useState([]);
  const [showFamilyData, setShowFamilyData] = useState([]);

  const [selectedMember, setSelectedMember] = useState(undefined);

  const announce = (msg) => {
    const el = document.getElementById("aria-live-region");
    if (el) {
      // el.textContent = "";
      setTimeout(() => {
        el.textContent = !el.textContent ? msg : "";
      }, 0);
    }
  };
  const handleChange = (e) => {
    setSearch((prevState) => e.target.value);
  };

  const selectFamily = (userData) => {
    const cureMember = userData;
    if (!userData.isprimary) {
      UserStore.setClientOrFamily("client", { from: "SELECT" });
      PerformanceStore.setFamOrClient({
        name: "client",
        id: userData.user_id,
      });
      ReportsStore.updatePortfolioReportFilterData(cureMember, "mod4");
      ReportsStore.updateTransactionFilterData(cureMember, "check3");
      ReportsStore.updateCorporateFilterData(cureMember);
    } else {
      ReportsStore.updatePortfolioReportFilterData("All", "mod5");
      ReportsStore.updateTransactionFilterData("All", "check4");
      ReportsStore.updateCorporateFilterData("All");
      UserStore.setClientOrFamily("fam");
      PerformanceStore.setFamOrClient({
        name: "fam",
        id: userData.user_id,
      });
    }
    UserStore.setIsPrimary(cureMember.isprimary);
    UserStore.setUserData(
      {
        ...cureMember,
        family_name: userData.family_name,
        allMembers: cureMember.isprimary,
      },
      "whileLogginIn",
    );
  };

  const navigate = useNavigate();

  useEffect(() => {
    window.onpopstate = () => {
      if (location.pathname === "/selectfamilies") {
        if (location?.state?.from && location?.state?.from === "switchFamily") {
        } else if (
          location?.state?.from &&
          location?.state?.from === "loginPage" &&
          AuthStore.isfirstTimeFamilySelected === false
        ) {
          logout();
          navigate("/login/employee");
        }
      }
    };
    // eslint-disable-next-line
  }, [location.pathname, navigate]);

  useEffect(() => {
    const htmlEl = document.getElementById("html");
    htmlEl.style.overflowY = "auto";
    getEmployeeFamilies();
  }, []);

  const handleNavigate = () => {
    if (
      UserStore.userData?.isheldaway === false &&
      UserStore.userData?.investmentHeldWith === "2"
    ) {
      // SettingsStore.callInvestmentsHeldWith("1");
    }
    AuthStore.getHealthCheckData(
      UserStore?.userData?.user_id,
      (data) => {
        if (data?.[0] && data?.[0]?.data === "0") {
          setCookie("showpopup", "1");
        } else {
          setCookie("showpopup", "0");
        }
      },
      (error) => {
        setCookie("showpopup", "1");
      },
    );

    const { isOffshoreOnly, navigateTo } = getOffshoreData();
    navigate(navigateTo, { state: isOffshoreOnly ? { from: OFFSHORE } : {} });
    setTimeout(() => {
      announce("Loading Home page");
    }, 50);
    AuthStore.updateIsfirstTimeFamilySelected(true);
  };

  function getEmployeeFamilies() {
    getValue("rememberedFamilyData")
      .then((data) => setRememberedFamilyData(data))
      .catch((e) => Log("Error", e));
    getValue("showFamilyData")
      .then((data) => setShowFamilyData(data))
      .catch((e) => Log("Error", e));
  }

  const sortedArray = useMemo(() => {
    let sortedData = rememberedFamilyData;
    if (sortedData && isSort === "asc") {
      sortedData = [...sortedData]?.sort();
    } else if (sortedData && isSort === "desc") {
      sortedData = [...sortedData]?.sort((a, b) =>
        b.family_name.localeCompare(a.family_name),
      );
    }
    setIsSorting(false);
    return sortedData;
  }, [isSort, rememberedFamilyData]);

  const familyArray = sortedArray?.filter((family) => {
    return (
      family.family_name.toLowerCase().includes(defsearch.toLowerCase()) ||
      family.memberList.some((e) => {
        return e.full_name.toLowerCase().includes(defsearch.toLowerCase());
      })
    );
  });

  const handleScrollStart = (e) => {
    const scrollTop = parentScroll.current.scrollTop;
    if (scrollTop >= 1) {
      searchInputRef?.current?.blur();
    }

    if (
      e.target.clientHeight + e.target.scrollTop + 2 > e.target.scrollHeight &&
      showFamilyData?.length
    ) {
      if (vertualRows) {
        setVertualRows((prev) => {
          if (prev) {
            return [
              ...prev,
              ...showFamilyData?.slice(prev?.length, prev?.length + 10),
            ];
          }
        });
      }
    }
  };

  function onConfirm(data = selectedMember) {
    setFullScreenLoading(true);

    setTimeout(() => {
      UserStore.setAsOfDate(null);
      selectFamily({
        ...data,
      });
      if (UserStore.getData === "fam") UserStore.setSelectedClientId("0");
      else UserStore.setSelectedClientId(data.user_id);
      if (UserStore.userData?.user_id) handleNavigate();
      ProfileStore2.getImage(
        UserStore.userData?.profile_pic ? UserStore.userData?.profile_pic : "",
        "normal",
      );
      setFullScreenLoading(false);
    }, 10);
    setCookie("name", data.full_name);
    UserStore.setConnectData([]);
    UserStore.setUserStoreData("secondaryRMDetails", defaultSecondaryRMData);
  }

  useEffect(() => {
    const mainData = rememberedFamilyData;

    const rowData = mainData?.filter((eachData) => {
      return (
        eachData.family_name.toLowerCase().includes(search.toLowerCase()) ||
        eachData.memberList.some((e) => {
          return e.full_name.toLowerCase().includes(search.toLowerCase());
        })
      );
    });

    if (rowData) {
      if (isSort === "desc") {
        setShowFamilyData(
          [...rowData]?.sort((a, b) =>
            b?.family_name.localeCompare(a?.family_name),
          ),
        );
      }
      if (isSort === "asc") {
        setShowFamilyData(
          [...rowData]
            ?.sort((a, b) => b?.family_name.localeCompare(a?.family_name))
            .reverse(),
        );
      }
    }
    // eslint-disable-next-line
  }, [search, isSort]);

  useEffect(() => {
    setVertualRows(showFamilyData?.slice(0, 10));
  }, [showFamilyData]);

  useEffect(() => {
    if (vertualRows?.length) {
      UserStore.downloadImagesOnApiCall(vertualRows);
    }
  }, [vertualRows]);

  useLayoutEffect(() => {}, []);

  useEffect(() => {
    setFullScreenLoading(false);
  }, []);

  useEffect(() => {
    if (UserStore.isHydrated && rememberedFamilyData?.length) {
      setShowFamilyData([...rememberedFamilyData]);
      setRememberedFamilyData([...rememberedFamilyData]);
    }
    // eslint-disable-next-line
  }, [UserStore.isHydrated, rememberedFamilyData?.length]);

  useEffect(() => {
    return () => {
      PerformanceStore.loaderCloseOnFail();
    };
  }, []);

  return (
    <Observer>
      {() =>
        UserStore.isHydrated &&
        !fullScreenLoading &&
        showFamilyData &&
        (vertualRows.length || search) ? (
          <>
            <Header isLogoNavigationEnabled={false} />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                selectedMember?.user_id && onConfirm();
              }}
            >
              <div className="outer_main_div">
                <div id="main_div" className="main_contaier_div">
                  <PageHeading
                    headingClass="families_title"
                    headingText="Select Family"
                  />
                  <>
                    <div
                      id="scollId"
                      ref={parentScroll}
                      className="select_families_scrollable"
                      onScroll={handleScrollStart}
                    >
                      <div className="select_families_seach_atoz_wrapper">
                        <InputSearch
                          width={"520px"}
                          name="search"
                          value={search}
                          handleChange={handleChange}
                          setSearch={setSearch}
                          paddingRight={"20px"}
                          paddingLeft={"21px"}
                          searchInputRef={searchInputRef}
                          ref={searchInputRef}
                        />
                        <div
                          onClick={() => {
                            setIsSorting(true);
                            setTimeout(() => {
                              switch (isSort) {
                                case "asc":
                                  setSort("desc");
                                  break;
                                case "desc":
                                  setSort("asc");
                                  break;
                                default:
                                  setSort("desc");
                                  break;
                              }
                            }, 0);
                          }}
                          className="select_families_atoz"
                        >
                          <AToZ isSorting={isSorting} isSort={isSort} />
                        </div>
                      </div>

                      {familyArray?.length ? (
                        <>
                          <div
                            ref={cardsRef}
                            id="cards"
                            className="families_cards"
                          >
                            {vertualRows.map(
                              ({ family_id, ...family }, index2, array) => (
                                <FamilyCardJs
                                  onSelect={(data) => {
                                    if (
                                      data.user_id === selectedMember?.user_id
                                    )
                                      onConfirm();
                                    else setSelectedMember(data);
                                  }}
                                  getFamilyMemberImageFrom={
                                    AuthStore.selectFamiliesPageAllImages
                                  }
                                  familyId={family_id}
                                  key={index2}
                                  familyDetails={family}
                                  ind={index2}
                                  len={array?.length}
                                  search={search}
                                  start={start}
                                  setStart={(data) => setStart(data)}
                                  selectedFamily={String(
                                    selectedMember?.family_id,
                                  )}
                                  selectedUser={selectedMember?.user_id}
                                />
                              ),
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="family_not_found">
                            <img src={noFamilyFound} alt="no family found" />
                            <p className="not_found_heading">
                              Family Name not found
                            </p>
                            <p className="not_found_text">
                              The name {search} did not match any Family member
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                    {familyArray?.length ? (
                      <div
                        ref={buttonRef}
                        id="buttons"
                        className="buttons_container"
                      >
                        <ArrowButton
                          type="previous"
                          label="Go Back"
                          onClick={() => {
                            if (location?.state?.from === "switchFamily") {
                              navigate(-1);
                            } else {
                              logout();
                              navigate("/login/employee");
                            }
                          }}
                          isTest={true}
                        />{" "}
                        <ArrowButton
                          styleProp={{
                            cursor: selectedMember?.user_id
                              ? "pointer"
                              : "not-allowed",
                          }}
                          disabled={!selectedMember?.user_id}
                          type="next"
                          label="Continue"
                          btnType="submit"
                          isTest={false}
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                  {/* )} */}
                </div>
              </div>
            </form>
          </>
        ) : (
          <LoadingScreen />
        )
      }
    </Observer>
  );
});

export default SelectFamilies;
